import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { UserListItem } from '../models/user-list.model';
import { TariffService } from './tariff.service';
import { Tariff } from '../models/tariff.model';


@Injectable({ providedIn: 'root' })
export class TariffListResolver implements Resolve<HttpResponse<Tariff[]>> {
  constructor(
    private userService: TariffService
  ) { }

  resolve() {
    const httpParams = new HttpParams().set('orderby', 'Id Asc');

    return this.userService.get(httpParams);
  }
}
